import { render, staticRenderFns } from "./ProductsSubCategory.vue?vue&type=template&id=b2366056&scoped=true"
import script from "./ProductsSubCategory.vue?vue&type=script&lang=js"
export * from "./ProductsSubCategory.vue?vue&type=script&lang=js"
import style0 from "./ProductsSubCategory.vue?vue&type=style&index=0&id=b2366056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2366056",
  null
  
)

export default component.exports